// Utilities for parsing/formatting keyword strings that may include
// quoted phrases (e.g. "No Kings").
//
// NOTE: preserve user-entered quotes — do NOT strip or auto-add quotes.

export function parseKeywords(str) {
  if (!str || !String(str).trim()) return [];
  const regex = /"[^"]+"|\S+/g;
  const tokens = [];
  let match;
  while ((match = regex.exec(str)) !== null) {
    // push the raw matched token so surrounding quotes (if any) are preserved
    tokens.push(match[0]);
  }
  return tokens;
}

export function formatKeywords(arr) {
  if (!Array.isArray(arr) || arr.length === 0) return '';
  // Join tokens exactly as provided by the user (do not add/strip quotes).
  return arr
    .filter(Boolean)
    .map((token) => String(token).trim())
    .join(' ')
    .trim();
}
